<template>
  <div>
    <div ref="upload" class="js-upload uk-placeholder uk-text-center">
      <span data-uk-icon="cloud-upload"></span>
      <span class="uk-text-middle uk-text-small"> Datei hier rein ziehen oder </span>
      <div data-uk-form-custom style="line-height: 0;">
        <input type="file" :multiple="multiple" />
        <span class="uk-link uk-text-small">klicken zum hochladen</span>
      </div>
    </div>
    <progress ref="progressbar" class="uk-progress" value="0" max="100" hidden></progress>
    <div class="uk-grid" v-if="isFile && uploaded.length">
      <div class="uk-width-1-1">
        <p class="uk-text-emphasis">
          <span data-uk-icon="icon:file-pdf; ratio:1.5"></span>
          {{ uploaded[0].originFilename }}
        </p>
      </div>
    </div>
    <div class="uk-grid" v-if="isImage && images.length">
      <div class="uk-width-1-1">
        <img :src="image" alt v-for="(image, i) in images" :key="i" />
      </div>
    </div>
    <div class="uk-text-right uk-margin-small-top" v-if="fileId">
      <a href="#" class="uk-icon-button uk-text-danger" uk-icon="trash" @click.prevent="remove()"></a>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Configuration from '@/configuration';
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      images: [],
      uploadComplete: false,
      uploaded: [],
      fileError: false,
      imageCount: 0,
      isImage: false,
      isFile: false,
      fileId: null
    }
  },

  mounted() {
    const $this = this
    const bar = this.$refs.progressbar
    this.$uikit.upload(this.$refs.upload, {
      url: `${this.url}`,
      multiple: this.multiple,
      name: 'file',
      params: {
        type: this.type,
      },

      beforeSend: e => e.headers = {'X-AUTH-TOKEN': Configuration.value('tenant')},
      beforeAll: (e, fileList) => {
        $this.uploaded = []
        $this.images = []
        $this.fileError = false
        let reader
        const files = fileList

        for (let i = 0; i < files.length; i++) {
          const file = files[i]

          if (file.type.match('image')) {
            $this.isImage = true

            reader = new FileReader()
            reader.onload = (e) => {
              $this.images.push(e.target.result)
            }
            reader.readAsDataURL(file)
          } else if (file.type.match('pdf')) {
            $this.isFile = true
          } else {
            continue
          }
        }
      },
      load: () => {},
      error: () => {},
      complete: (e) => {
        const json = JSON.parse(e.response)
        $this.uploaded.push(json)
        $this.imageCount++
        this.fileId = json.id
        // $this.$emit('uploaded', json)
        $this.$emit('input', json.id)
      },
      loadStart: (e) => {
        bar.removeAttribute('hidden')
        bar.max = e.total
        bar.value = e.loaded
      },
      progress: (e) => {
        bar.max = e.total
        bar.value = e.loaded
      },
      loadEnd: (e) => {
        bar.max = e.total
        bar.value = e.loaded
      },
      completeAll: () => {
        // setTimeout(function () {
        bar.setAttribute('hidden', 'hidden')
        // }, 1000);
        $this.uploadComplete = true
      }
    })
  },
  methods: {
    remove() {
      axios
        .post(
          `https://b2b.dc2.ansolution.de/merchant/register/remove-file/${this.fileId}`, {}, {
          headers: {
            'X-AUTH-TOKEN': Configuration.value('tenant')
          }
        })
        .then(() => {
          this.uploaded = []
          this.images = []
          this.fileId = null
          this.$emit('input', null)
        })
    }
  }
}
</script>
